export default {
  toggleTilt (behavior) { this.toggleFeature(behavior, window.H.mapevents.Behavior.Feature.TILT) },
  toggleHeading (behavior) { this.toggleFeature(behavior, window.H.mapevents.Behavior.Feature.HEADING) },
  togglePanning (behavior) { this.toggleFeature(behavior, window.H.mapevents.Behavior.Feature.PANNING) },
  togglePinchZoom (behavior) { this.toggleFeature(behavior, window.H.mapevents.Behavior.Feature.PINCH_ZOOM) },
  toggleWheelZoom (behavior) { this.toggleFeature(behavior, window.H.mapevents.Behavior.Feature.WHEEL_ZOOM) },
  toggleDoubleTapZoom (behavior) { this.toggleFeature(behavior, window.H.mapevents.Behavior.Feature.DBL_TAP_ZOOM) },
  toggleFractionalZoom (behavior) { this.toggleFeature(behavior, window.H.mapevents.Behavior.Feature.FRACTIONAL_ZOOM) },
  toggleFeature (behavior, feature) {
    if (behavior.isEnabled(feature)) {
      behavior.disable(feature)
      return
    }
    behavior.enable(feature)
  },
  toggleUsedFeatures (behavior) {
    this.togglePanning(behavior)
    this.togglePinchZoom(behavior)
    this.toggleWheelZoom(behavior)
    this.toggleDoubleTapZoom(behavior)
    this.toggleFractionalZoom(behavior)
  }
}




// WEBPACK FOOTER //
// ./src/components/SearchForm/_map-behavior-utils.js